class ArchiveWalletTemplateWorkflow {
    constructor($injector) {
        this.injector = $injector;
        this.state = this.injector.get('$state');
        this.http = this.injector.get('$http');
        this.alert = this.injector.get('Alert');
        this.translate = this.injector.get('$translate');

        this.key = 'archive-passbook';
        this.title = this.translate.instant('general.verbs.archive');
        this.level = 'highlight';
        this.icon = 'trash-alt';

    }

    translatedValue(path, params) {
        return this.translate.instant(`wallets.templates.workflows.details.ask-to-archive-template.${path}`, params);
    }

    action(template, vm) {
        this.alert.animatedAlert(
            this.translatedValue('title'),
            this.translatedValue(
                'content',
                {
                    wallet_ticket_name: template.name
                }
            ),
            'attention',
            {
                confirmButtonText: this.translatedValue('confirm'),
                cancelButtonText: this.translatedValue('cancel'),
            },
        )
            .then(() => {
                this.http.put(`wallets/templates/${template.id}/archive`)
                    .then(() => {
                        this.state.go(
                            'app.wallets.templates.details',
                            {
                                id: template.id
                            },
                            {
                                reload: true
                            }
                        );
                    })
                    .catch(err => this.alert.handle(err));
            })
            .catch(err => this.alert.handle(err));
    }

}

angular
    .module('festzelt-os.modules.wallets.templates')
    .factory('archivePassbook', [
        '$injector',
        ($injector) => new ArchiveWalletTemplateWorkflow($injector)
    ]);



// WEBPACK FOOTER //
// ./src/app/modules/wallets/templates/workflows/details/archive.js